import { injectable, inject } from "inversify";

import "reflect-metadata";
import ToastService from "./toast.service";
import IdentityService from "./identity.service";
import * as React from "react";
import {resolve} from "inversify-react";
import {container} from "../inversify.config";

export function getCookie(name) {
    var cookieValue: any = null;
    if (document.cookie && document.cookie !== "") {
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === name + "=") {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
@injectable()
export default class HttpService {
    public get domainName() {
        return (window as any).SITE_CONFIG.baseUrl;
    }

    public get domainUrl() {
        return (window as any).SITE_CONFIG.baseUrl;
    }

    @inject(ToastService)
    public toastService: ToastService;

    public async handleError(error: Response) {
        if (error.status === 400) {
            try {
                const res = error.clone();
                const json = await res.json();
                this.toastService.showToast("Invalid data" , json.message || [], "error");
            } catch (e) {
                this.toastService.showToast("Invalid data", [], "error");
            }
            return;
        } else if (error.status >= 401 && error.status < 500) {
            var errors: React.ReactNode[] = [];

            errors.push(error.statusText);
            /*for(var k in json)
                errors.push(`${k}:  ${json[k]}`);*/

            this.toastService.showToast("Error", errors, "error");
            if (error.status === 403) {
                const identity = container.get(IdentityService);
                identity.logout();
                window.location.href = "/";
            }
            return;
        } else if (error.status >= 500) {
            var js = await error.text();
            this.toastService.showToast("Server error", `${error.statusText} ${js}`, "error");
        }
    }

    public post<T>(url: string, data: T, headers?: { [id: string]: string }, disableFeedback?: boolean): Promise<T> {
        const params = this.getUrl(`${url}`, headers);

        this.operationUp();

        return new Promise<T>((resolve, reject) => {
            fetch(params.url, {
                headers: { ...params.headers, "X-CSRFToken": getCookie("csrftoken") },
                method: "POST",
                body: JSON.stringify(data),
            })
                .then((result) => {
                    this.operationDown();
                    if (result.status >= 200 && result.status < 400) {
                        result
                            .json()
                            .then((js) => {
                                resolve(js);
                            })
                            .catch((error) => {
                                reject(undefined);
                            });
                    } else {
                        if (!disableFeedback) {
                            this.handleError(result);
                        }
                        result
                            .json()
                            .then((result) => {
                                reject(result);
                            })
                            .catch((error) => {
                                reject(null);
                            });
                    }
                })
                .catch((error) => {
                    reject(error);
                    this.operationDown();
                    this.handleError(error);
                });
        });
    }

    public postFormData<T>(url: string, data: FormData, headers?: { [id: string]: string }, disableFeedback?: boolean): Promise<T> {
        const params = this.getUrl(`${url}`, headers);

        this.operationUp();

        return new Promise<T>((resolve, reject) => {
            fetch(params.url, {
                headers: {
                    ...headers,
                    "X-CSRFToken": getCookie("csrftoken"),
                    ContentType: "multipart/form-data",
                },
                method: "POST",
                body: data,
            })
                .then((result) => {
                    this.operationDown();
                    if (result.status >= 200 && result.status < 400) {
                        result
                            .json()
                            .then((js) => {
                                resolve(js);
                            })
                            .catch((error) => {
                                reject(undefined);
                            });
                    } else {
                        if (!disableFeedback) {
                            this.handleError(result);
                        }
                        result
                            .json()
                            .then((result) => {
                                reject(result);
                            })
                            .catch((error) => {
                                reject(null);
                            });
                    }
                })
                .catch((error) => {
                    reject(error);
                    this.operationDown();
                    this.handleError(error);
                });
        });
    }

    public postFull<T>(url: string, data: T, headers?: { [id: string]: string }, disableFeedback?: boolean): Promise<Response> {
        const params = this.getUrl(`${url}`, headers);

        this.operationUp();

        return new Promise<Response>((resolve, reject) => {
            fetch(params.url, {
                headers: { ...params.headers, "X-CSRFToken": getCookie("csrftoken") },
                method: "POST",
                body: JSON.stringify(data),
            })
                .then((result) => {
                    this.operationDown();
                    if (result.status >= 200 && result.status < 400) {
                        resolve(result);
                    } else {
                        if (!disableFeedback) {
                            this.handleError(result);
                        }
                        result
                            .json()
                            .then((result) => {
                                reject(result);
                            })
                            .catch((error) => {
                                console.log(error);
                                reject(null);
                            });
                    }
                })
                .catch((error) => {
                    reject(error);
                    this.operationDown();
                    this.handleError(error);
                });
        });
    }

    public patch<T>(url: string, data: T, headers?: { [id: string]: string }, disableFeedback?: boolean): Promise<T> {
        const params = this.getUrl(`${url}`, headers);

        this.operationUp();

        return new Promise<T>((resolve, reject) => {
            fetch(params.url, {
                headers: { ...params.headers, "X-CSRFToken": getCookie("csrftoken") },
                method: "PATCH",
                body: JSON.stringify(data),
            })
                .then((result) => {
                    this.operationDown();
                    if (result.status >= 200 && result.status < 400) {
                        result
                            .json()
                            .then((js) => {
                                resolve(js);
                            })
                            .catch((error) => {
                                reject(undefined);
                            });
                    } else {
                        if (!disableFeedback) {
                            this.handleError(result);
                        }
                        result
                            .json()
                            .then((result) => {
                                reject(result);
                            })
                            .catch((error) => {
                                reject(null);
                            });
                    }
                })
                .catch((error) => {
                    reject(error);
                    this.operationDown();
                    this.handleError(error);
                });
        });
    }

    public async put<T>(url: string, data: any, headers?: { [id: string]: string }, disableFeedback?: boolean): Promise<T> {
        const params = this.getUrl(`${url}`, headers);

        this.operationUp();
        return new Promise<T>((resolve, reject) => {
            fetch(params.url, {
                headers: { ...params.headers, "X-CSRFToken": getCookie("csrftoken") },
                method: "PUT",
                body: JSON.stringify(data),
            })
                .then((result) => {
                    this.operationDown();
                    if (result.status >= 200 && result.status < 400) {
                        result
                            .json()
                            .then((js) => {
                                resolve(js);
                            })
                            .catch((error) => {
                                reject(undefined);
                            });
                    } else {
                        if (!disableFeedback) {
                            this.handleError(result);
                        }
                        result
                            .json()
                            .then((result) => {
                                reject(result);
                            })
                            .catch((error) => {
                                reject(null);
                            });
                    }
                })
                .catch((error) => {
                    this.operationDown();
                    reject(error);
                    this.handleError(error);
                });
        });
    }

    public async delete(url: string, data: any, headers?: { [id: string]: string }, disableFeedback?: boolean): Promise<any> {
        const params = this.getUrl(`${url}`, headers);

        this.operationUp();
        return new Promise<any>((resolve, reject) => {
            fetch(params.url, {
                headers: { ...params.headers, "X-CSRFToken": getCookie("csrftoken") },
                method: "DELETE",
                body: JSON.stringify(data),
            })
                .then((result) => {
                    this.operationDown();
                    if (result.status >= 200 && result.status < 400) {
                        result
                            .json()
                            .then((js) => {
                                resolve(js);
                            })
                            .catch((error) => {
                                resolve(undefined);
                            });
                    } else {
                        if (!disableFeedback) {
                            this.handleError(result);
                        }
                        result
                            .json()
                            .then((result) => {
                                reject(result);
                            })
                            .catch((error) => {
                                reject(null);
                            });
                    }
                })
                .catch((error) => {
                    reject(error);
                    this.operationDown();
                    this.handleError(error);
                });
        });
    }

    public async get<T>(url: string, headers?: { [id: string]: string }, disableFeedback?: boolean, pure?: boolean): Promise<T> {
        const params = this.getUrl(`${url}`, headers);

        this.operationUp();

        return new Promise<any>((resolve, reject) => {
            fetch(pure ? url : params.url, { headers: params.headers, method: "GET" })
                .then((result) => {
                    this.operationDown();
                    if (result.status >= 200 && result.status < 400) {
                        result
                            .json()
                            .then((js) => {
                                resolve(js);
                            })
                            .catch((error) => {
                                resolve(undefined);
                            });
                    } else {
                        if (!disableFeedback) {
                            this.handleError(result);
                        }
                        result
                            .json()
                            .then((result) => {
                                reject(result);
                            })
                            .catch((error) => {
                                reject(null);
                            });
                    }
                })
                .catch((error) => {
                    reject(error);
                    this.operationDown();
                    this.handleError(error);
                });
        });
    }

    public async getFull<T>(url: string, headers?: { [id: string]: string }, disableFeedback?: boolean, pure?: boolean): Promise<Response> {
        const params = this.getUrl(`${url}`, headers);

        this.operationUp();

        return new Promise<Response>((resolve, reject) => {
            fetch(pure ? url : params.url, { headers: params.headers, method: "GET" })
                .then((result) => {
                    this.operationDown();
                    if (result.status >= 200 && result.status < 400) {
                        resolve(result);
                    } else {
                        if (!disableFeedback) {
                            this.handleError(result);
                        }
                        result
                            .json()
                            .then((result) => {
                                reject(result);
                            })
                            .catch((error) => {
                                reject(null);
                            });
                    }
                })
                .catch((error) => {
                    reject(error);
                    this.operationDown();
                    this.handleError(error);
                });
        });
    }

    public getQueryString(data: any) {
        const result: string[] = [];

        for (const k in data) {
            if (!!data[k]) {
                result.push(`${encodeURI(k)}=${encodeURI(data[k])}`);
            }
        }

        return result.join("&");
    }

    protected getUrl(url: string, headers?: { [id: string]: string }): { url: string; headers: {} } {
        const baseUrl = (window as any).SITE_CONFIG.baseUrl;

        return {
            url: `${baseUrl}/api/${url}`,
            // tslint:disable-next-line:object-literal-sort-keys
            headers: { "Content-Type": "application/json", ...headers },
        };
    }

    private operationUp() {
        (window as any).store.dispatch({ type: "AJAX_OPERATION_UP" });
    }

    private operationDown() {
        (window as any).store.dispatch({ type: "AJAX_OPERATION_DOWN" });
    }
}



// WEBPACK FOOTER //
// ./src/services/http.service.ts